import React from 'react';

import { Select } from 'components/ui/select';
import { formatMetrics } from '../metrics/helpers';
import { useConversationContext } from '../conversation_context';

import type { Metrics } from '../types';

export default function AdminToolbar() {
  const { agent, agents, changeAgent, changeModel, messages, model, showAdminDetails } = useConversationContext();

  if (!showAdminDetails) {
    return null;
  }

  const models = agent?.models || [];
  const aggregateMetrics: Metrics = { cost: null, latencyMs: null };


  for (const message of messages) {
    if (message.metrics?.cost != null) {
      aggregateMetrics.cost ||= 0;
      aggregateMetrics.cost += message.metrics.cost;
    }

    if (message.metrics?.latencyMs != null) {
      aggregateMetrics.latencyMs ||= 0;
      aggregateMetrics.latencyMs += message.metrics.latencyMs;
    }
  }

  return (
    <div className="border-bottom px-3 py-2">
      <div className="d-flex align-items-center gap-2">
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <Select
            getOptionLabel={agent => agent.label}
            getOptionValue={agent => agent.name}
            options={agents}
            value={agent}
            onChange={changeAgent}
          />
        </div>

        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <Select
            getOptionLabel={model => `${model.id} · ${model.provider}`}
            getOptionValue={model => model.id}
            options={models}
            value={model}
            onChange={changeModel}
          />
        </div>
      </div>

      <div className="text-muted small text-nowrap text-end mt-1" title="Session LLM latency and spend">
        {formatMetrics(aggregateMetrics)}
      </div>
    </div>
  );
}
